import {
  IAddress,
  IAddUpdateCustomerPageState,
  IcreateUserPayload,
  IcreateUserResponse,
  ICustomerConfigResponse,
  INewCustomerResponseObject,
  ISelectDropdownOption,
  IPartnerChannel
} from "../interfaces/Index";

export const normalizeCreateCustomerResponse = (res: IcreateUserResponse) => {
  return (
    res && {
      id: res.userId,
      name: res.userName,
    }
  );
};

export const  getLongitudeAndLatitude = (coOrdinates: any) => {
  const splitString = coOrdinates.trim().split(",");
  return {
    latitude: splitString[0].trim(),
    longitude: splitString[splitString.length - 1].trim(),
  };
}

export const normalizeCustomerStatus = (
  isValid: boolean,
  statusText: string
) => {
  if (isValid) {
    return "ACTIVE";
  } else {
    if (statusText === "SUSPENDED") {
      return "SUSPENDED";
    } else if (statusText === "UNVERIFIED") {
      return "UNVERIFIED";
    } else if (statusText === "PENDING") {
      return "PENDING";
    }
     else {
      return "INACTIVE";
    }
  }
};

export const normalizeCustomerReqPayload = (
  req: IcreateUserPayload, zoneId: string = "", partnerChannels: Array<IPartnerChannel>) => {
  const coordinates = getLongitudeAndLatitude(req.coOrdinates);
  return {
    name: req.customerName,
    phone: req.phoneNumber,
    password: req.password,
    passwordConfirmation: req.password,
    storeName: req.storeName,
    storeType: (req.storeType as any).label,
    latitude: coordinates.latitude,
    longitude: coordinates.longitude,
    address: req.address,
    nationalId: req.cnicNumber,
    zoneId: zoneId,
    incomeTaxStatus: req.incomeTaxStatus ? "ACTIVE_FILER" : "INACTIVE_FILER",
    registrationType: req.registrationType ? "REGISTERED" : "UNREGISTERED",
    partners: partnerChannels
  };
};

export const normalizeFetchCustomerResponse = (
  res: Array<INewCustomerResponseObject>,
  pagination: any,
  isPaginatedRes: boolean
) => {
  let payload: any = {
    pagination: res.length === 50 ? pagination : false,
    isPaginatedRes,
  };
  const customerPayload = res.map((customer) => {
    const address: IAddress = customer.address;
    return {
      id: customer.id,
      // customerEmail: customer.email,
      customerName: customer.ownerName,
      storeType: customer.storeType,
      // customerLastName: customer.lastName,
      customerPhone: customer.phoneNumber,
      customerStatus: customer.status,
      userStatus: customer.userStatus,
      addressId: address ? address.id : null,
      address: address ? address.address : "",
      zoneId: address ? address.zoneId : "",
      customerStore: customer.name,
      customerChannel: customer.customerChannel,
      isChecked: false,
      createdAt: "", // customer.createdAt || "",
      coOrdinates: address
        ? (address.latitude.toString() || "") +
          ", " +
          (address.longitude.toString() || "")
        : "",
      userId: customer.user.userId,
      incomeTaxStatus: customer.incomeTaxStatus === "ACTIVE_FILER",
      registrationType: customer.registrationType === "REGISTERED",
      partnerChannels: customer.partnerChannels || []
    };
  });
  payload.customerData = customerPayload;
  return payload;
};

export const normalizeCustomerUpdateReqPayload = (
  state: IAddUpdateCustomerPageState,
  selectedCustomer: any,
  zoneId: string = "",
  partnerChannels: Array<IPartnerChannel>
  // metaFields: Array<any>
) => {
  let reqPayload: any = {};
  const objectPair = (e: any) => {
    if(typeof(e) === "string") {
      return e
    } else {
      return e.label
    }
  }

  const coordinates = getLongitudeAndLatitude(state.coOrdinates);

  // let metaData: Array<any> = generateMetaFieldsPayload(
  //   metaFields,
  //   state.status ? "ACTIVE" : "INACTIVE",
  //   coordinates
  // );

  let addressData: any;
  addressData = {
    id: selectedCustomer.addressId,
    address: state.address,
    company: state.storeName,
    zoneId: zoneId
  };

  reqPayload.id = selectedCustomer.id;
  reqPayload.name = state.customerName;
  reqPayload.phone = state.phoneNumber;
  reqPayload.status = normalizeCustomerStatus(state.status.isValid, state.status.text);
  reqPayload.userStatus = state.userStatus ? "ACTIVE" : "INACTIVE";
  reqPayload.addressDetails = addressData;
  reqPayload.nationalId = state.cnicNumber;
  reqPayload.coordinates = coordinates;
  // reqPayload.metaFields = metaData;
  reqPayload.storeType = objectPair(state.storeType);
  reqPayload.userId = selectedCustomer.userId;
  reqPayload.incomeTaxStatus = state.incomeTaxStatus ? 'ACTIVE_FILER' : "INACTIVE_FILER";
  reqPayload.registrationType = state.registrationType ? 'REGISTERED' : "UNREGISTERED";
  reqPayload.partners = partnerChannels;

  // if (state.password && state.confirmPassword) {
  //   reqPayload.password = state.password;
  //   reqPayload.passwordConfirmation = state.confirmPassword;
  // }

  return reqPayload;
};
 
export const normalizeOrderCustomerSearchResponse = (res: any) => {
  return res.customerData.map((customer: any) => {
    return {
      value: customer.customerStore,
      label: `${customer.customerStore} - ${customer.customerPhone}`,
      storeName: customer.customerStore,
      storeAddress: customer.address || "",
      number: customer.customerPhone,
      customerId: customer.id,
      zoneId: customer.zoneId,
      customerChannel: customer.customerChannel,
      partnerChannels: customer.partnerChannels || []
    };
  });
};

export const normalizeStoreType = (storeType: any) => {
  return storeType.map((type: any) => {
   return {
      id: type.name ? type.name.replace(/ /g,"_").toUpperCase() : type.value,
      value: type.value ? type.value : "",
      label: type.name ? type.name : "",
    };
  });
};


export const normalizeCustomerConfigResponse = (response: any): ICustomerConfigResponse => {
  const mappedCustomerChannels = response.customerChannels.map((option: string): ISelectDropdownOption => {
    option = (option || "")
    return {
      id: option.toUpperCase(),
      title: option,
      value: option,
      label: option,
      isChecked: false,
    };
  });

  return {
    customerChannels: mappedCustomerChannels
  };
};